import { doLogout } from "actions/authAction";
import { BASE_URL } from "../actions/constant";

// CONST
export const GET_DATA_LOADING = "GET_DATA_LOADING_MKT";
export const GET_DATA_SUCCESS = "GET_DATA_SUCCESS_MKT";
export const GET_DATA_ERROR = "GET_DATA_ERROR_MKT";
export const IS_FORM_OPEN = "IS_FORM_OPEN_MKT";
export const IS_FORM_CLOSE = "IS_FORM_CLOSE_MKT";
export const IS_FORM_ERROR = "IS_FORM_ERROR_MKT";
export const IS_ACTION_PROCESS = "IS_ACTION_PROCESS_MKT";
export const IS_ACTION_SUCCESS = "IS_ACTION_SUCCESS_MKT";
export const IS_ACTION_FAILURE = "IS_ACTION_FAILURE_MKT";
export const DATA_TIPE_CARGO_PROCESS = "DATA_TIPE_CARGO_PROCESS";
export const DATA_TIPE_CARGO_SUCCESS = "DATA_TIPE_CARGO_SUCCESS";
export const DATA_TIPE_CARGO_FAILURE = "DATA_TIPE_CARGO_FAILURE";

// INITIAL STATE
export const INITIAL_STATE_GET_DATA = { loading: false, data: [], error: false };
export const INITIAL_STATE_IS_FORM = { active: false, save: true, data: [], error: false };
export const INITIAL_STATE_IS_ACTION = { loading: false, method: "", data: [], error: false };
export const INITIAL_STATE_TIPE_CARGO = { loading: false, data: [], error: false };

// FUNCTION

const getDataLoading = () => {
    return {
        ...INITIAL_STATE_GET_DATA,
        type: GET_DATA_LOADING,
        loading: true,
    };
};

const getDataSuccess = (data) => {
    return {
        ...INITIAL_STATE_GET_DATA,
        type: GET_DATA_SUCCESS,
        data,
    };
};

const getDataError = () => {
    return {
        ...INITIAL_STATE_GET_DATA,
        type: GET_DATA_ERROR,
        error: true,
    };
};

const isFormOpen = (bool, data) => {
    return {
        ...INITIAL_STATE_IS_FORM,
        type: IS_FORM_OPEN,
        active: true,
        save: bool,
        data: data,
    };
};

const isFormClose = () => {
    return {
        ...INITIAL_STATE_IS_FORM,
        type: IS_FORM_CLOSE,
    };
};

const isFormError = (bool, data) => {
    return {
        ...INITIAL_STATE_IS_FORM,
        type: IS_FORM_ERROR,
        active: true,
        save: bool,
        data: data,
        error: true,
    };
};

const isActionProcess = (method, data) => {
    return {
        ...INITIAL_STATE_IS_ACTION,
        type: IS_ACTION_PROCESS,
        loading: true,
        method: method,
        data: data,
    };
};

const isActionSuccess = (method, data) => {
    return {
        ...INITIAL_STATE_IS_ACTION,
        type: IS_ACTION_SUCCESS,
        method: method,
        data: data,
    };
};

const isActionFailure = () => {
    return {
        ...INITIAL_STATE_IS_ACTION,
        type: IS_ACTION_FAILURE,
        error: true,
    };
};

const tipeCargoLoading = () => {
    return {
        ...INITIAL_STATE_TIPE_CARGO,
        type: DATA_TIPE_CARGO_PROCESS,
        loading: true,
    };
};

const tipeCargoSuccess = (data) => {
    return {
        ...INITIAL_STATE_TIPE_CARGO,
        type: DATA_TIPE_CARGO_SUCCESS,
        data,
    };
};

const tipeCargoFailure = () => {
    return {
        ...INITIAL_STATE_TIPE_CARGO,
        type: DATA_TIPE_CARGO_FAILURE,
        error: true,
    };
};

export function isForm(status, save, data = []) {
    return (dispatch) => {
        switch (status) {
            case "open":
                dispatch(isFormOpen(save, data));
                break;
            case "close":
                dispatch(isFormClose());
                break;
            case "error":
                dispatch(isFormError(save, data));
                break;
            default:
                dispatch(isFormClose());
        }
    };
}

export function getData(params = []) {
    let parameter = {};

    parameter["page"] = params.page ? params.page : "";
    parameter["sizePerPage"] = params.sizePerPage ? params.sizePerPage : "";
    parameter["kodeTrayek"] = params.kodeTrayek ? params.kodeTrayek : "";
    parameter["tahunTrayek"] = params.tahunTrayek ? params.tahunTrayek : "";
    parameter["statusTrayek"] = params.statusTrayek ? params.statusTrayek : "";
    parameter["id_operator"] = params.id_operator ? params.id_operator : "";
    parameter["trayek"] = params.trayek ? params.trayek : "";
    parameter["ruas"] = params.ruas ? params.ruas : "";
    parameter["id"] = params.id ? params.id : "";

    return (dispatch) => {
        dispatch(getDataLoading());

        let token = localStorage.getItem("tolaut@token") || null;
        let config = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        };
        const {
            page,
            sizePerPage,
            kodeTrayek,
            tahunTrayek,
            statusTrayek,
            id_operator,
            trayek,
            ruas,
            id,
        } = parameter;
        let urlParams = `?`;
        if (page !== "" && sizePerPage !== "") {
            urlParams += `&page=${page}&limit=${sizePerPage}`;
        }

        if (kodeTrayek !== "") {
            urlParams += `&kodeTrayek=${kodeTrayek}`;
        }

        if (tahunTrayek !== "") {
            urlParams += `&tahunTrayek=${tahunTrayek}`;
        }

        if (statusTrayek !== "") {
            urlParams += `&statusTrayek=${statusTrayek}`;
        }

        if (id_operator !== "") {
            urlParams += `&idOperator=${id_operator}`;
        }

        if (trayek !== "") {
            urlParams += `&kodeTrayek=${trayek}`;
        }

        if (ruas !== "") {
            urlParams += `&ruas=${ruas}`;
        }

        if (id !== "") {
            urlParams += `&id=${id}`;
        }

        fetch(BASE_URL + "master_kode_trayek/" + urlParams, config)
            .then((response) => {
                if (response.status === 401) {
                    dispatch(doLogout());
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 400) {
                    dispatch(getDataError());
                } else {
                    dispatch(getDataSuccess(data.data));
                }
            })
            .catch((e) => {
                dispatch(getDataError());
            });
    };
}

const GET_DATA_FILTER_TRAYEK = "GET_DATA_FILTER_TRAYEK";

const getDataListLoading = () => {
    return {
        type: GET_DATA_FILTER_TRAYEK + "_LOADING",
    };
};
const getDataListError = () => {
    return {
        type: GET_DATA_FILTER_TRAYEK + "_ERROR",
    };
};
const getDataListSucccess = (data) => {
    return {
        type: GET_DATA_FILTER_TRAYEK + "_SUCCESS",
        data: data,
    };
};

export function getDataList() {
    return (dispatch) => {
        dispatch(getDataListLoading());

        let token = localStorage.getItem("tolaut@token") || null;
        let config = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        };
        fetch(BASE_URL + "master_kode_trayek/?&statusTrayek=1", config)
            .then((response) => {
                if (response.status === 401) {
                    dispatch(doLogout());
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 400) {
                    dispatch(getDataListError());
                } else {
                    dispatch(getDataListSucccess(data.data.data));
                }
            })
            .catch((e) => {
                dispatch(getDataListError());
            });
    };
}

export function isActions(method, params) {
    return (dispatch) => {
        let token = localStorage.getItem("tolaut@token") || null;
        let getConfig = {};
        let urlAction = BASE_URL + "master_kode_trayek/";

        switch (method) {
            case "ADD":
                getConfig["method"] = "POST";
                // getConfig['url'] = urlAction;
                getConfig["body"] = JSON.stringify(params);
                break;
            case "DELETE":
                getConfig["method"] = "DELETE";
                // getConfig['url'] = urlAction + params.id;
                // urlAction = urlAction + params.id;
                getConfig["body"] = JSON.stringify(params);
                break;
            case "EDIT":
                getConfig["method"] = "POST";
                // getConfig['url'] = urlAction + params.id;
                urlAction = urlAction + params.id;
                getConfig["body"] = JSON.stringify(params);
                break;
            default:
                getConfig = {};
                break;
        }

        getConfig["headers"] = {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        };

        dispatch(isActionProcess(getConfig.method, getConfig.body));

        fetch(urlAction, getConfig)
            .then((response) => {
                if (response.status === 401) {
                    dispatch(doLogout());
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 400) {
                    alert(data.message);
                    dispatch(isActionFailure());
                    dispatch(isFormError(true, params));
                } else {
                    dispatch(isActionSuccess(method, INITIAL_STATE_IS_ACTION));
                    dispatch(isFormClose());
                    dispatch(getData({ page: 1, sizePerPage: 5 }));
                }
            })
            .catch((e) => {
                dispatch(isActionFailure());
            });
    };
}

export function getTipeCargo() {
    return (dispatch) => {
        dispatch(tipeCargoLoading());

        let token = localStorage.getItem("tolaut@token") || null;
        let config = {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        };

        fetch(BASE_URL + "master_tipe_cargo", config)
            .then((response) => {
                if (response.status === 401) {
                    dispatch(doLogout());
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 400) {
                    dispatch(tipeCargoFailure());
                } else {
                    dispatch(tipeCargoSuccess(data.data));
                }
            })
            .catch((e) => {
                dispatch(tipeCargoFailure());
            });
    };
}
const spokeViewError = (bool) => {
    return {
        type: "SPOKE_VIEW_ERROR",
        spokeViewError: bool,
    };
};
const spokeViewSuccess = (bool, spoke) => {
    return {
        type: "SPOKE_VIEW_SUCCESS",
        spokeViewSuccess: bool,
        spoke,
    };
};
const spokeViewLoading = (bool) => {
    return {
        type: "SPOKE_VIEW_LOADING",
        spokeViewLoading: bool,
    };
};
export function spokeFetchOne(id) {
    return (dispatch) => {
        dispatch(spokeViewError(false));
        dispatch(spokeViewSuccess(false, null));
        dispatch(spokeViewLoading(true));

        let token = localStorage.getItem("tolaut@token") || null;
        let config = {};
        if (token) {
            config = {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            };
        } else {
            throw Error("Authentication error");
        }
        fetch(BASE_URL + `trayek_spoke/${id}`, config)
            .then((response) => {
                if (response.status === 401) {
                    dispatch(doLogout());
                }
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                dispatch(spokeViewLoading(false));
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                dispatch(spokeViewSuccess(true, data));
            })
            .catch((err) => {
                dispatch(spokeViewError(true));
            });
    };
}
